(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clinical-study-tabs"] && !Shopify.designMode) return;
  try {
    
  class SfClinicalTabs extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('.clinical-study-tabs__panel'));
      this.tablist = this.querySelector('.clinical-study-tabs__tablist');
      if (!this.panels.length || !this.tablist) return;

      this.buttons = this.panels.map((panel, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'clinical-study-tabs__tab-btn label';
        button.setAttribute('role', 'tab');
        button.id = `${panel.id}-tab`;
        button.setAttribute('aria-controls', panel.id);
        button.textContent = panel.dataset.tabLabel;
        button.addEventListener('click', () => this._activate(index, true));
        this.tablist.appendChild(button);
        panel.setAttribute('aria-labelledby', button.id);
        return button;
      });

      this.tablist.addEventListener('keydown', this._onKeydown.bind(this));
      this._activate(0, false);

      this.panels.forEach((panel) => this._bindCompare(panel));
    }

    _activate(index, focusButton) {
      this.panels.forEach((panel, i) => {
        const active = i === index;
        panel.hidden = !active;
        this.buttons[i].setAttribute('aria-selected', String(active));
        this.buttons[i].tabIndex = active ? 0 : -1;
      });
      this._current = index;
      if (focusButton) this.buttons[index].focus();
    }

    _onKeydown(event) {
      const last = this.buttons.length - 1;
      let next = this._current;
      if (event.key === 'ArrowRight') next = this._current === last ? 0 : this._current + 1;
      else if (event.key === 'ArrowLeft') next = this._current === 0 ? last : this._current - 1;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = last;
      else return;
      event.preventDefault();
      this._activate(next, true);
    }

    _bindCompare(panel) {
      const pairs = Array.from(panel.querySelectorAll('.clinical-study-tabs__pair'));
      if (pairs.length < 2) return;
      let current = 0;
      const show = (index) => {
        pairs.forEach((pair, i) => pair.classList.toggle('is-active', i === index));
        current = index;
      };
      panel
        .querySelector('.clinical-study-tabs__nav--prev')
        ?.addEventListener('click', () => show((current - 1 + pairs.length) % pairs.length));
      panel
        .querySelector('.clinical-study-tabs__nav--next')
        ?.addEventListener('click', () => show((current + 1) % pairs.length));
    }
  }

  if (!customElements.get('sf-clinical-tabs')) {
    customElements.define('sf-clinical-tabs', SfClinicalTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tab-collection]').forEach(function (root) {
    var pills = root.querySelectorAll('[data-tab-collection-pill]');
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (other) {
          var active = other === pill;
          other.classList.toggle('current', active);
          other.setAttribute('aria-selected', active ? 'true' : 'false');
          var panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.headerBounds = {};
  
      window.requestAnimationFrame(this.setHeaderHeight.bind(this));
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      window.addEventListener('resize', this.setHeaderHeight.bind(this));
  
      this.currentScrollTop = 0;
      this.onScrollHandler = this.onScroll.bind(this);
  
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
  
    setHeaderHeight() {
      const announcementHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;

      // L'announcement bar è ora DENTRO la sezione header: stickano insieme a top 0.
      this.header.style.top = '0px';
      this.header.style.position = 'sticky';
      this.header.style.zIndex = '100';
  
      const totalHeaderHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--current-headers-height', `${totalHeaderHeight}px`);
      document.documentElement.style.setProperty('--current-announcement-height', `${announcementHeight}px`);
    }
  
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
      window.removeEventListener('resize', this.setHeaderHeight);
    }
  
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
  
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const threshold = this.headerBounds.bottom || this.header.offsetHeight || 50;
  
      if (scrollTop > threshold) {
        this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky');
      } else {
        this.header.classList.remove('scrolled-past-header', 'shopify-section-header-sticky');
      }
  
      this.currentScrollTop = scrollTop;
    }
  
    hide() {}
  
    reveal() {
      this.header.classList.add('shopify-section-header-sticky');
    }
  
    reset() {
      this.header.classList.remove('shopify-section-header-sticky');
    }
  }
  
  customElements.define('sticky-header', StickyHeader);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ribbon-gallery"]) return;
  try {
    
  (() => {
    const touchQuery = window.matchMedia('(max-width: 749px), (hover: none)');

    const init = (root) => {
      if (!root || root.dataset.ribbonReady) return;
      root.dataset.ribbonReady = 'true';

      const track = root.querySelector('.ribbon-gallery__track');
      const toggle = root.querySelector('.ribbon-gallery__toggle');
      if (!track) return;

      const setPaused = (paused) => {
        track.classList.toggle('is-paused', paused);
        if (!toggle) return;
        const label = paused ? toggle.dataset.playLabel : toggle.dataset.stopLabel;
        toggle.textContent = label;
        toggle.setAttribute('aria-label', label);
        toggle.setAttribute('aria-pressed', String(paused));
      };

      const viewport = root.querySelector('.ribbon-gallery__viewport');
      const groups = track.querySelectorAll('.ribbon-gallery__group');

      let lastWidth = 0;

      // Repeat the card set inside each half until one half covers the viewport, so the loop never shows its end.
      const fill = () => {
        const width = viewport.clientWidth;
        if (width === lastWidth) return;
        lastWidth = width;
        track.style.animationTimingFunction = '';
        groups.forEach((group) => {
          group.querySelectorAll('.is-clone').forEach((clone) => clone.remove());
          const originals = [...group.children];
          const setWidth = group.scrollWidth;
          if (!originals.length || !setWidth) return;
          const copies = Math.max(0, Math.ceil(width / setWidth) - 1);
          for (let i = 0; i < copies; i += 1) {
            originals.forEach((card) => {
              const clone = card.cloneNode(true);
              clone.classList.add('is-clone');
              clone.classList.remove('is-open');
              clone.setAttribute('aria-pressed', 'false');
              clone.setAttribute('aria-hidden', 'true');
              clone.setAttribute('tabindex', '-1');
              [...clone.attributes]
                .filter((attr) => attr.name.startsWith('data-shopify'))
                .forEach((attr) => clone.removeAttribute(attr.name));
              group.append(clone);
            });
          }
        });
        // One step per CSS pixel keeps the track on whole pixels, so moving images are not resampled every frame.
        const distance = Math.round(groups[0]?.offsetWidth || 0);
        if (distance) track.style.animationTimingFunction = `steps(${distance})`;
      };

      fill();
      new ResizeObserver(fill).observe(viewport);

      toggle?.addEventListener('click', () => setPaused(!track.classList.contains('is-paused')));

      viewport.addEventListener('click', (event) => {
        const card = event.target.closest('.ribbon-gallery__card');
        if (!card) {
          if (touchQuery.matches) setPaused(true);
          return;
        }
        const open = card.classList.toggle('is-open');
        card.setAttribute('aria-pressed', String(open));
        if (touchQuery.matches) setPaused(!!track.querySelector('.ribbon-gallery__card.is-open'));
      });
    };

    document.querySelectorAll('.ribbon-gallery').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      init(event.target.querySelector('.ribbon-gallery'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
